const DESIGNS_BY_INDUSTRY = [
    {
        title: 'a_logo',
        link: '/logo-maker/ideas/monograms/letter-a',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042368/letter-a.png',
    },
    {
        title: 'b_logo',
        link: '/logo-maker/ideas/monograms/letter-b',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042371/letter-b.png',
    },
    {
        title: 'c_logo',
        link: '/logo-maker/ideas/monograms/letter-c',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042375/letter-c.png',
    },
    {
        title: 'd_logo',
        link: '/logo-maker/ideas/monograms/letter-d',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042367/letter-d.png',
    },
    {
        title: 'e_logo',
        link: '/logo-maker/ideas/monograms/letter-e',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042385/letter-e.png',
    },
    {
        title: 'f_logo',
        link: '/logo-maker/ideas/monograms/letter-f',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042371/letter-f.png',
    },
    {
        title: 'g_logo',
        link: '/logo-maker/ideas/monograms/letter-g',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042373/letter-g.png',
    },
    {
        title: 'h_logo',
        link: '/logo-maker/ideas/monograms/letter-h',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042373/letter-h.png',
    },
    {
        title: 'i_logo',
        link: '/logo-maker/ideas/monograms/letter-i',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042387/letter-i.png',
    },
    {
        title: 'j_logo',
        link: '/logo-maker/ideas/monograms/letter-j',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042363/letter-j.png',
    },
    {
        title: 'k_logo',
        link: '/logo-maker/ideas/monograms/letter-k',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042387/letter-k.png',
    },
    {
        title: 'l_logo',
        link: '/logo-maker/ideas/monograms/letter-l',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042386/letter-l.png',
    },
    {
        title: 'm_logo',
        link: '/logo-maker/ideas/monograms/letter-m',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042369/letter-m.png',
    },
    {
        title: 'n_logo',
        link: '/logo-maker/ideas/monograms/letter-n',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042364/letter-n.png',
    },
    {
        title: 'o_logo',
        link: '/logo-maker/ideas/monograms/letter-o',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042388/letter-o.png',
    },
    {
        title: 'p_logo',
        link: '/logo-maker/ideas/monograms/letter-p',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042367/letter-p.png',
    },
    {
        title: 'q_logo',
        link: '/logo-maker/ideas/monograms/letter-q',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042364/letter-q.png',
    },
    {
        title: 'r_logo',
        link: '/logo-maker/ideas/monograms/letter-r',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042382/letter-r.png',
    },
    {
        title: 's_logo',
        link: '/logo-maker/ideas/monograms/letter-s',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042388/letter-s.png',
    },
    {
        title: 't_logo',
        link: '/logo-maker/ideas/monograms/letter-t',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042378/letter-t.png',
    },
    {
        title: 'u_logo',
        link: '/logo-maker/ideas/monograms/letter-u',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042370/letter-u.png',
    },
    {
        title: 'v_logo',
        link: '/logo-maker/ideas/monograms/letter-v',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042381/letter-v.png',
    },
    {
        title: 'w_logo',
        link: '/logo-maker/ideas/monograms/letter-w',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042381/letter-w.png',
    },
    {
        title: 'x_logo',
        link: '/logo-maker/ideas/monograms/letter-x',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042368/letter-x.png',
    },
    {
        title: 'y_logo',
        link: '/logo-maker/ideas/monograms/letter-y',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042368/letter-y.png',
    },
    {
        title: 'z_logo',
        link: '/logo-maker/ideas/monograms/letter-z',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3900332eabbe0500561990b94e086bff-1618903042388/letter-z.png',
    },
];

const HERO_IMG_URL = 'dae9f6c9bc4421d963604abc91ad52bb-1619784684894/Monograms_SEO_banner.png';

const TEASER_CONTENT = [
    {
        id: 1,
        class: 'add-logo',
    },
    {
        id: 2,
        class: 'create-variations',
    },
    {
        id: 3,
        class: 'ai-working',
    },
];

const IDEAS_HUB_ACTIONS = {
    START_BRIEF: 'Start brief',
    TAG_CLICKED: 'Tag clicked',
};

const IDEAS_HUB_SECTIONS = {
    HEADER_CTA: 'Header CTA',
    INDUSTRIES: 'Industries',
    STYLES: 'Styles',
    MAKE_YOUR_LOGO: 'Make your logo',
    POPULAR_KEYWORDS: 'Popular Keywords',
    FOOTER: 'Footer',
};

export { DESIGNS_BY_INDUSTRY, HERO_IMG_URL, TEASER_CONTENT, IDEAS_HUB_ACTIONS, IDEAS_HUB_SECTIONS };
